// Postes opérationnels (interfaces) et calcul des accès par rôle.
// Le RBAC réel est appliqué côté backend : ces accès contrôlent uniquement
// quelles interfaces l'utilisateur peut ouvrir (jamais un privilège supérieur à son rôle).
export const STATIONS = {
  manager: { key: "manager", label: "Manager", route: "/manager" },
  pos: { key: "pos", label: "Caisse / POS", route: "/pos" },
  kds: { key: "kds", label: "Cuisine / KDS", route: "/kds" },
};

const ORDER = ["manager", "pos", "kds"];
const MANAGER_ROLES = ["admin", "owner", "manager"];
const ROLE_STATIONS = {
  admin: ["manager", "pos", "kds"],
  owner: ["manager", "pos", "kds"],
  manager: ["manager", "pos", "kds"],
  server: ["pos"],
  kitchen: ["kds"],
};

// Postes autorisés = postes du rôle ∪ postes supplémentaires accordés par le Manager.
// Le poste "Manager" reste réservé au Propriétaire/Manager, jamais accordé à un rôle inférieur.
export function allowedStations(user) {
  const role = user?.role;
  const base = ROLE_STATIONS[role] || [];
  const extra = Array.isArray(user?.extra_stations) ? user.extra_stations : [];
  const set = new Set([...base, ...extra]);
  return ORDER.filter((s) => set.has(s) && (s !== "manager" || MANAGER_ROLES.includes(role)));
}

export function defaultStation(user) {
  const role = user?.role;
  if (role === "kitchen") return "kds";
  if (role === "server") return "pos";
  const a = allowedStations(user);
  return a.includes("manager") ? "manager" : (a[0] || "pos");
}
